import styled from 'styled-components';
import { Card } from 'styles';

export const StyledCard = styled(Card).attrs({
  mobileVariant: 'flat',
  role: 'alert',
})`
  padding: 24px;
`;
